<template>
    <MobileHeaderBack closeText></MobileHeaderBack>
    <div class="info-container">
        <AccountInfo 
            :type="$route.query.id"
            v-if="$route.query.id" />
    </div>
</template>

<script>
    import MobileHeaderBack from "@/components/mobile/HeaderBack.vue";
    import AccountInfo from '@/components/account/AccountInfo.vue'
    export default {
        name: 'Info',
        components: {
            AccountInfo,
            MobileHeaderBack
        },
        computed: {
            
        }
    }
</script>

<style scoped>
.info-container {
    padding: 24px;
    box-sizing: border-box;
    background-color: var(--color-background-default-secondary);
    min-height: calc(100vh - 66.07px);
}
</style>